console.log('components');

import './components/slider';
import './components/accordion';
import './components/scroll';
import './components/modal';
import './components/ellipsis';
import './components/observe';
import './components/card';
